import React from 'react';
import { ExpandButton, AvatarIcon as Avatar } from '@lt/components';
import avatarWebp from '../../../../images/avatar/avatar.webp';
import avatarPng from '../../../../images/avatar/avatar.png';
import styles from './ReviewBlock.module.css';
import { clickExpandButtonAnalytics } from './analytics';

interface ReviewBlockPropsType {
  title: string;
  description: string;
  avatarImages?: {
    jpg: string;
    webp: string;
  };
  avatarName: string;
  avatarDescription: string;
}
export const ReviewBlock = ({
  avatarName,
  avatarDescription,
  avatarImages,
  title,
  description,
}: ReviewBlockPropsType): JSX.Element => (
  <div className={styles.container}>
    <span className={styles.title}>{title}</span>
    <div className={styles.expertsContainer}>
      <div className={styles.expertAvatar}>
        <Avatar
          avatarUrlWebp={avatarImages ? avatarImages.webp : avatarWebp}
          avatarUrl={avatarImages ? avatarImages.jpg : avatarPng}
          size={40}
          name={avatarName}
        />
      </div>

      <div className={styles.expertInfo}>
        <p className={styles.expertName}>{avatarName}</p>
        <p className={styles.expertDescription}>{avatarDescription}</p>
      </div>
    </div>
    <ExpandButton
      content={description}
      visibleLine={2}
      onClickExpandButton={clickExpandButtonAnalytics}
    />
  </div>
);
